import GatewaySelectorUi from './GatewaySelectorUi';

export default GatewaySelectorUi;
